<template>
    <div class="activity-content card-box-style rounded">
        <div class="main-title mb-0 d-flex justify-content-between align-items-center">
            <h3>Activity Statistics</h3>

            <select class="form-select form-control" aria-label="Default select example">
                <option selected>7 days</option>
                <option value="1">15 days</option>
                <option value="2">10 days</option>
                <option value="3">5 days</option>
            </select>
        </div>

        <div class="sessions-chart">
            <div class="chart-wrap">
                <div id="chart">
                    <apexchart type="candlestick" height="245" :options="chartOptions" :series="series"></apexchart>
                </div>
            </div>
        </div>

        <ul class="activity-wrap">
            <li class="single-activity">
                <span class="title">Lessons (Avg)</span>
                <h4>35.56%</h4>
            </li>
            <li class="single-activity border-style-4fcb8d">
                <span class="title">Tasks (Avg)</span>
                <h4>64.44%</h4>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'ActivityStatisticsChart',
    data: function() {
        return {
            series: [{
                data: [{
                    x: new Date(15388452e5),
                    y: [6595.97, 6602.01, 6588.17, 6602]
                }, {
                    x: new Date(1538847e6),
                    y: [6602, 6607, 6596.51, 6599.95]
                }, {
                    x: new Date(15388488e5),
                    y: [6600.63, 6601.21, 6590.39, 6591.02]
                }, {
                    x: new Date(15388506e5),
                    y: [6591.02, 6603.08, 6591, 6591]
                }, {
                    x: new Date(15388524e5),
                    y: [6591, 6601.32, 6585, 6592]
                }, {
                    x: new Date(15388542e5),
                    y: [6593.13, 6596.01, 6590, 6593.34]
                }, {
                    x: new Date(1538856e6),
                    y: [6593.34, 6604.76, 6582.63, 6593.86]
                }, {
                    x: new Date(15388578e5),
                    y: [6593.86, 6604.28, 6586.57, 6600.01]
                }, {
                    x: new Date(15388596e5),
                    y: [6601.81, 6603.21, 6592.78, 6596.25]
                }, {
                    x: new Date(15388614e5),
                    y: [6596.25, 6604.2, 6590, 6602.99]
                }, {
                    x: new Date(15388632e5),
                    y: [6602.99, 6606, 6584.99, 6587.81]
                }, {
                    x: new Date(1538865e6),
                    y: [6587.81, 6595, 6583.27, 6591.96]
                }, {
                    x: new Date(15388668e5),
                    y: [6591.97, 6596.07, 6585, 6588.39]
                }, {
                    x: new Date(15388686e5),
                    y: [6587.6, 6598.21, 6587.6, 6594.27]
                }, {
                    x: new Date(15388704e5),
                    y: [6596.44, 6601, 6590, 6596.55]
                }, {
                    x: new Date(15388722e5),
                    y: [6598.91, 6605, 6596.61, 6600.02]
                }, {
                    x: new Date(1538874e6),
                    y: [6600.55, 6605, 6589.14, 6593.01]
                }, {
                    x: new Date(15388758e5),
                    y: [6593.15, 6605, 6592, 6603.06]
                }]
            }],
            chartOptions: {
                title: {
                    text: "",
                    align: "left"
                },
                xaxis: {
                    type: "datetime",
                    labels: {
                        style: {
                            colors: "#A9A9C8",
                        },
                    }
                },
                yaxis: {
                    tooltip: {
                        enabled: !0
                    },
                    labels: {
                        style: {
                            colors: "#A9A9C8",
                        },
                    }
                },
                plotOptions: {
                    candlestick: {
                        colors: {
                            upward: '#4FCB8D',
                            downward: '#1765FD'
                        }
                    }
                }
            },
        };
    },
}
</script>

<style lang="scss">
.activity-content {
	margin-bottom: 24px;
}
.activity-wrap {
	padding: 0;
	margin-bottom: 0;
	list-style: none;
	display: inline-block;
	.single-activity {
		padding-left: 10px;
		position: relative;
		display: inline-block;
		margin-right: 30px;
		margin-top: 5px;
		&:last-child {
			margin-right: 0;
		}
		&::before {
			content: "";
			position: absolute;
			top: 0;
			left: 0;
			width: 2px;
			height: 100%;
			background-color: #1765fd;
			border-radius: 30px;
		}
		.title {
			font-size: 13px;
			font-weight: 500;
			letter-spacing: -0.26px;
			display: block;
			margin-bottom: 4px;
		}
		h4 {
			font-size: 14px;
			span {
				font-size: 11px;
				color: #BCC2CF;
				font-weight: 500;
			}
		}
		&.border-style-5c31d6 {
			&::before {
				background-color: #5c31d6;
			}
		}
		&.border-style-4fcb8d {
			&::before {
				background-color: #4fcb8d;
			}
		}
		&.border-style-fec107 {
			&::before {
				background-color: #fec107;
			}
		}
	}
}

/* Min width 1400px to Max width 1700px */
@media only screen and (min-width: 1400px) and (max-width: 1700px) {
    .activity-wrap {
        .single-activity {
            margin-top: 15px;
        }
    }
}
</style>